export default "/images/ed34dbeed06bffec7a6c3f8c6b9f3c93.png";